import styled from 'styled-components';
import { useContext, RefObject } from 'react';

import { Button } from '@/ui/Button';
import { CourseNavigationContext } from '@/administration/pages/Course/MainLayoutView/atoms/NavigationActions/CourseNavigationProvider';

const RootStyled = styled.div`
  display: flex;
  align-items: center;
`;

export const RetakeSection = ({ onRetakeClick }: { onRetakeClick: () => void }): JSX.Element => {
  const { retakeQuizButtonRef, forceNavigationUpdateRef, quizHasPassed } = useContext(CourseNavigationContext);

  const handleRef = (element: HTMLButtonElement | null) => {
    (retakeQuizButtonRef as { current: HTMLButtonElement | null }).current = element;
    !!forceNavigationUpdateRef?.current && forceNavigationUpdateRef.current();
  };

  return (
    <RootStyled>
      <Button
        icon={['far', 'arrows-repeat']}
        variant={quizHasPassed ? 'secondary' : 'primary'}
        onClick={onRetakeClick}
        size="large"
        outerRef={handleRef as unknown as RefObject<HTMLDivElement>}
      >
        Retake
      </Button>
    </RootStyled>
  );
};
